import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const CarsTable = Loadable(lazy(() => import('pages/cars/carsTable')));
const ListVoTable = Loadable(lazy(() => import('pages/cars/listVoTable')));
const ListVoKanban = Loadable(lazy(() => import('pages/cars/listVoKanban')));

// ==============================|| CARS ROUTING ||============================== //

const CarsRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'cars',
          element: <CarsTable />
        },
        {
          path: 'list-vo',
          element: <ListVoKanban />
        },
        {
          path: 'available-cars',
          element: <ListVoKanban />
        },
        {
          path: '/list-vo/:id',
          element: <ListVoTable />
        }
      ]
    }
  ]
};

export default CarsRoutes;
